// k3s-staging build target (Story 37.21 Task 5) — the in-cluster nginx image
// for the STAGE k3s stack; twin of environment.k3s-development.ts.
//
// The DEPLOYED bundle is origin-agnostic: `resolveApiBase()` (Story 27.9)
// uses `window.location.origin` on any non-localhost host, so the SPA is
// same-origin with the API on k3s-validate.staging today and on the
// canonical auth.staging host after the 37.21 Task 8 flip with NO rebuild.
// `authUrl` below is therefore the localhost-only fallback (ng serve /
// karma). recaptchaSiteKey is the STAGE site key (matches
// environment.stage.ts and values/stage/discovery.yaml's
// RECAPTCHA_SITE_KEY — the three must agree or captcha_required logins
// fail with only "Security check failed" client-side, the dev lesson).
export const environment = {
    authUrl: "https://auth.staging.emjo-consulting.dk",
    appName: "Emjo OAuth",
    recaptchaSiteKey: '6Le6s_8sAAAAAOFsqfRcu-bpaidJOUn73Hb0h8_j' //gitleaks:allow -- public reCAPTCHA site key (shipped to browser)
};
